let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("24jzf")).then(() => parcelRequire('3ji4Q'));